import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {IsTestBookedConfiguration} from './types'

export const buildIsTestBookedConfiguration = ({
  options
}: BuildConfigurationInput): IsTestBookedConfiguration => {
  return {
    testing: options.constraints.isTestBooked
  }
}
